import { IconProps, IconType } from '@/common/icons/types.ts'
import { cn } from '@/common/utilities.ts'

export const WarningIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-information-1', type, className)}></i>
}
